module.exports = __webpack_public_path__ + "static/img/jinka.7f8ad4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/vip/jinka.png
// module id = 4xrw
// module chunks = 2